function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Layout from '@4c/layout';
import styled from 'astroturf'
import classNames from 'classnames';
import React from 'react';
import Button from './Button';
import Heading from './Heading';
const styles = require('./Header-styles.module.scss');

function Header({
  children,
  className,
  ...props
}) {
  return React.createElement(Layout, _extends({}, props, {
    pad: true,
    align: "center",
    className: classNames(className, styles.header)
  }), children);
}

Header.Title = /*#__PURE__*/styled(Heading, null, {
  displayName: "HeaderTitle",
  styles: require("./Header-HeaderTitle.module.scss"),
  attrs: props => ({ ...props,
    truncate: true
  }),
  vars: []
});
Header.Actions = /*#__PURE__*/styled(Layout, null, {
  displayName: "HeaderActions",
  styles: require("./Header-HeaderActions.module.scss"),
  attrs: null,
  vars: []
});
Header.Action = /*#__PURE__*/styled(Button, null, {
  displayName: "HeaderAction",
  styles: require("./Header-HeaderAction.module.scss"),
  attrs: props => ({ ...props,
    theme: 'link'
  }),
  vars: []
});
export default Header;